import fetch from '@/utils/request'

const request = (rest = {}) => fetch({ ...rest, privateFlag: true })

export default {
  // 电子药品说明书统计数据
  getStatisticsOverview(data) {
    return request({
      url: `/emi/statistics/overview`,
      method: 'POST',
      data
    })
  },
}
